// Mode admin : l'équipe Kaiylo est dans l'espace d'un coach, ouvert par un lien
// à usage unique (/admin/coachs → /acces-admin) dans une fenêtre privée.
// Tant que ce marqueur existe : bandeau « Mode admin », pas de PostHog, pas
// d'abonnement push, et la déconnexion ne ferme que cette session (jamais
// celles du coach sur ses appareils).
const KEY = 'kaiylo_admin_view';

export function getAdminView() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function setAdminView(view) {
  try {
    localStorage.setItem(KEY, JSON.stringify(view));
  } catch {
    // Stockage bloqué : le bandeau ne s'affichera pas, la session reste utilisable.
  }
}

export function clearAdminView() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Ignore
  }
}
